import React, { useState } from 'react';
import './CouponsList.css';

function CouponsList({ coupons, loading }) {
  const [expandedId, setExpandedId] = useState(null);

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p>Loading coupons...</p>
      </div>
    );
  }

  if (coupons.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-icon">🎟️</div>
        <h3>No coupons yet</h3>
        <p>Coupons and deals will be automatically saved here when detected.</p>
      </div>
    );
  }

  const formatDate = (date) => {
    const d = new Date(date);
    return d.toLocaleDateString();
  };

  return (
    <div className="coupons-list">
      <div className="coupons-grid">
        {coupons.map(coupon => (
          <div key={coupon._id} className="coupon-card">
            <div className="coupon-header">
              <div className="coupon-icon">🎟️</div>
              <div className="coupon-meta">
                <h3>{coupon.subject}</h3>
                <p className="coupon-from">{coupon.from}</p>
                <p className="coupon-date">{formatDate(coupon.date)}</p>
              </div>
            </div>
            
            <button 
              className="expand-btn"
              onClick={() => setExpandedId(expandedId === coupon._id ? null : coupon._id)}
            >
              {expandedId === coupon._id ? '▼' : '▶'}
            </button>

            {expandedId === coupon._id && (
              <div className="coupon-details">
                <div className="coupon-body">
                  {coupon.body}
                </div>
                <button className="copy-btn">
                  📋 Copy Details
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default CouponsList;
